import { render, staticRenderFns } from "./EditGroupForm.vue?vue&type=template&id=3c4a66fc&"
import script from "./EditGroupForm.vue?vue&type=script&lang=js&"
export * from "./EditGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports